export function logResponse(response, urlPath, method = 'POST', alias = '') {
  const { data } = response;
  if (data.trackingId) {
    console.log('RESPONSE: ', alias, data.trackingId, method, urlPath, data);
  } else {
    console.log('RESPONSE: ', alias, response, method, urlPath, data);
  }
}

export default logResponse;
